/**Dependencies */
import React from "react";

/**Components */
import { Button, Col, Row, ListGroup } from "react-bootstrap";

/**
 * Componente que muestra una lista desplegable de destinos que coinciden con
 * la busqueda realizada. Si no hay resultados, muestra una lista de 6 destinos
 * sugeridos.
 *
 * @param {Array<string>} destinos - La lista de destinos totales
 * @param {boolean} showComponent - Indica si se debe mostrar el componente
 * @param {Array<string>} filteredDestinations - La lista de destinos que coinciden con la b squeda
 * @param {Function} handleDestinationClick - Funci n que se ejecuta al hacer clic en un destino
 * @param {Function} handleClose - Funci n que se ejecuta al hacer clic en el bot n "Listo"
 * @returns {JSX.Element} El componente
 */
export const DestinationList = ({
  preDestinies,
  showDestinationList,
  query,
  filteredDestinations,
  filteredHotels,
  filteredTerminals,
  handleSelectItem,
  handleSelectedTerminal,
  isHotel,
  isTraslados,
  isTrasladosHotel,
  showTerminalList,
  showDestinationListHotels,
  isCheckedTraslado,
  isHome,
  handleClose,
  isModify,
  isAct,
}) => {
  return (
    <div>
      {showDestinationList && query !== "" && (
        <div
          className={
            "p-3 border shadow-sm bg-white" + (isModify ? " w-100" : " w-70")
          }
          style={
            isModify
              ? {
                  left: "0",
                  position: "absolute",
                  borderRadius: "35px",
                  zIndex: "999999",
                  //overflowY: "scroll",
                }
              : {
                  //top: "50px",
                  left: "0",
                  position: "absolute",
                  borderRadius: "35px",
                  zIndex: "999999",
                  //overflowY: "scroll",
                }
          }
        >
          <Row className="text-start" style={{ maxHeight: "17rem", overflowY: "auto" }}>
            {/* Resultados de Destinos */}
            <Col lg={12}>
              <ListGroup>
                <h5
                  style={{
                    padding: "0.5rem",
                    zIndex: "999999",
                    borderBottom: "1px solid rgb(94, 94, 94)",
                  }}
                >
                  Destinos
                </h5>
                {filteredDestinations?.length > 0 && query !== "" ? (
                  <>
                    {filteredDestinations?.map((destino) => (
                      <>
                        <ListGroup.Item
                          style={{ border: "none" }}
                          key={destino.id}
                          onClick={() =>
                            handleSelectItem(
                              destino.id,
                              destino.nombre,
                              "destino"
                            )
                          }
                        >
                          {" "}
                          {destino.nombre}
                        </ListGroup.Item>
                      </>
                    ))}
                  </>
                ) : (
                  <ListGroup.Item>No se encontraron destinos</ListGroup.Item>
                  //   <>
                  //     <h5 className="text-center text-black py-5">
                  //       Algunos destinos para viajar...
                  //     </h5>
                  //     <Row>
                  //       {preDestinies.slice(0, 6).map((destino, index) => (
                  //         <Col
                  //           xs={12}
                  //           md={6}
                  //           className="mb-4 text-center"
                  //           key={index}
                  //         >
                  //           <Button
                  //             variant="outline-secondary"
                  //             className="w-100"
                  //             onClick={() =>
                  //               handleSelectItem(
                  //                 destino.id,
                  //                 destino.nombre,
                  //                 "destino"
                  //               )
                  //             }
                  //             style={{ borderRadius: "20px", height: "55px" }}
                  //           >
                  //             {destino.nombre}
                  //           </Button>
                  //         </Col>
                  //       ))}
                  //     </Row>
                  //   </>
                )}
              </ListGroup>
            </Col>
            {/* Resultados de Hoteles */}
            {isHotel && (
              <Col lg={12}>
                <h5
                  style={{
                    padding: "0.5rem",
                    zIndex: "999999",
                    borderBottom: "1px solid rgb(94, 94, 94)",
                  }}
                >
                  Hoteles
                </h5>
                <ListGroup>
                  {filteredHotels.length > 0 ? (
                    filteredHotels.map((hotel) => (
                      <ListGroup.Item
                        style={{ border: "none" }}
                        key={hotel.id_atv3}
                        onClick={() =>
                          handleSelectItem(hotel.id_atv3, hotel.nombre, "hotel")
                        }
                      >
                        {hotel.nombre}
                      </ListGroup.Item>
                    ))
                  ) : (
                    <ListGroup.Item>No se encontraron hoteles</ListGroup.Item>
                  )}
                </ListGroup>
              </Col>
            )}
          </Row>
          <div className="text-center mt-3 d-flex justify-content-center border-top">
            <Col lg={filteredDestinations.length > 0 ? 8 : 10}>
              <Button
                className="btn-blue fw-bold"
                style={{ borderRadius: "20px", width: "100%", height: "50px" }}
                onClick={handleClose}
              >
                Listo
              </Button>
            </Col>
          </div>
        </div>
      )}
      {showTerminalList && query !== "" && (
        <div
          className={` p-3 border shadow-sm bg-white
             ${
               ""
               // isCheckedTraslado === "desdeAe"
               //   ? styles.destinationsContainerTraslado
               //   : styles.destinationsContainerTrasladoHacia
             }
          `}
          style={
            isModify
              ? {
                  left: "0",
                  position: "absolute",
                  borderRadius: "35px",
                  zIndex: "999999",
                  overflowY: "scroll",
                }
              : {
                  position: "absolute",
                  borderRadius: "35px",
                  zIndex: "999999",
                  overflowY: "scroll",
                }
          }
        >
          <Row className="text-start">
            {isTraslados && (
              <Col lg={12}>
                <h5
                  style={{
                    padding: "0.5rem",
                    zIndex: "999999",
                    borderBottom: "1px solid rgb(94, 94, 94)",
                  }}
                >
                  Terminales
                </h5>
                <ListGroup>
                  {filteredTerminals?.length > 0 ? (
                    filteredTerminals?.map((terminal) => (
                      <ListGroup.Item
                        style={{ border: "none" }}
                        key={terminal?.id}
                        onClick={() =>
                          handleSelectedTerminal(
                            terminal?.code,
                            terminal?.description,
                            terminal?.type_terminal
                          )
                        }
                      >
                        {terminal?.description}
                      </ListGroup.Item>
                    ))
                  ) : (
                    <ListGroup.Item style={{ border: "none" }}>
                      No se encontraron Terminales
                    </ListGroup.Item>
                  )}
                </ListGroup>
              </Col>
            )}
          </Row>
        </div>
      )}
      {showDestinationListHotels && query !== "" && (
        <div
          className={`${
            " p-3 border shadow-sm bg-white"
            // isCheckedTraslado === "haciaAe"
            //   ? styles.destinationsContainerHotelHacia
            //   : styles.destinationsContainerHotel
          }`}
          style={
            isModify
              ? {
                  left: "0",
                  position: "absolute",
                  borderRadius: "35px",
                  zIndex: "99999",
                  overflowY: "scroll",
                }
              : {
                  position: "absolute",
                  borderRadius: "35px",
                  zIndex: "99999",
                  overflowY: "scroll",
                }
          }
        >
          <Row className="text-start">
            {/* Resultados de Hoteles */}
            {isTrasladosHotel && (
              <Col lg={12}>
                <h5
                  style={{
                    padding: "0.5rem",
                    borderBottom: "1px solid rgb(94, 94, 94)",
                  }}
                >
                  Hoteles
                </h5>
                <ListGroup>
                  {filteredHotels?.length > 0 ? (
                    filteredHotels?.map((hotel) => (
                      <ListGroup.Item
                        style={{ border: "none" }}
                        key={hotel?.id_atv3}
                        onClick={() =>
                          handleSelectItem(hotel.id_atv3, hotel?.nombre, "H")
                        }
                      >
                        {hotel?.nombre}
                      </ListGroup.Item>
                    ))
                  ) : (
                    <ListGroup.Item style={{ border: "none" }}>
                      No se encontraron hoteles
                    </ListGroup.Item>
                  )}
                </ListGroup>
              </Col>
            )}
          </Row>
        </div>
      )}
    </div>
  );
};
